export default __webpack_public_path__ + "static/media/3responsive.cde8e748.jpeg";